import {
    createCollectionReducerWithKey
} from 'app/react/state/reducers/higher_order/_index'
import * as Account from 'app/react/entities/accounts/helpers'
import {
    ENTITY_REDUCER_KEY,
    COLLECTION_REDUCER_KEY
} from './schemas'
import {
    ALL_TYPES,
} from './actions'

const entityReducer = (state = {}) => state;

const collectionReducer = createCollectionReducerWithKey({
    mapActionToKey: ({ accountId }) =>
        Account.generateCollectionKey(accountId),
    types: ALL_TYPES
});

export const entityReducers = {
    [ENTITY_REDUCER_KEY]: entityReducer,
};

export const collectionReducers = {
    [COLLECTION_REDUCER_KEY]: collectionReducer,
};
